<template>
  <div class="user-info-withdraw-wrapper">
    <display-navigation
      :title="data.title + '-' + data.name"
      path="user_info"
    />
    <div class="content-wrapper">
      <van-field
        size="large"
        type="number"
        class="input"
        placeholder="请输入提现金额"
        :value="value"
        @input="handleChange"
      >
        <template v-slot:left-icon>
          <span>￥</span>
        </template>
      </van-field>
      <van-cell>可提现金额：￥{{ data.money }}</van-cell>
      <van-cell>已提现金额：￥{{ data.txMoney }}</van-cell>
      <van-cell>总返利金额：￥{{ data.totalMoney }}</van-cell>
      <van-cell
        >上次提现时间:{{
          data.lastTxDate !== null
            ? new Date(data.lastTxDate * 1000).toLocaleString()
            : ''
        }}</van-cell
      >
    </div>
    <div class="action-wrapper">
      <van-button class="btn" size="large" type="primary" @click="handleSubmit"
        >发起提现申请</van-button
      >
    </div>
    <van-cell
      title="提现规则："
      class="rules-wrapper"
      label="提现金额必须大于或等于￥1。"
    />
  </div>
</template>

<script>
import { userInAgent, submitUserInAgent } from '../../../api/api-user';

import DisplayNavigation from '../../../components/DisplayNavigation';

export default {
  components: {
    DisplayNavigation,
  },
  data() {
    return {
      data: {},
      value: 0,
    };
  },
  created() {
    this.handleLoad();
  },
  methods: {
    handleChange(val) {
      if (val) {
        this.value = parseFloat(val);
      }
    },
    checkFields() {
      return new Promise((resolve, reject) => {
        if (this.value > this.data.money)
          reject(new Error('提现金额不能超过可提现金额'));
        if (this.value < 1) reject(new Error('提现金额不能小于1'));
        const decimal = this.value.toString().split('.')[1];
        if (decimal && decimal.length > 2)
          reject(new Error('提现金额格式有误'));
        resolve(this.value);
      });
    },
    back() {
      this.$router.push({ name: 'user_info' });
    },
    async handleLoad() {
      const {
        title,
        total_money: totalMoney,
        tx_money: txMoney,
        money,
        name,
        last_tx_date: lastTxDate,
      } = await userInAgent();
      this.data = {
        title,
        totalMoney,
        txMoney,
        money,
        name,
        lastTxDate,
      };
    },
    async handleSubmit() {
      try {
        const money = await this.checkFields();
        await submitUserInAgent({ money });
        this.$toast.success('申请提交成功');
        window.setTimeout(() => {
          this.back();
        }, 1000);
      } catch (e) {
        this.$toast.fail(e.message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.user-info-withdraw-wrapper {
  .content-wrapper {
    background: #fff !important;
    .input {
      margin: 8px 0;
    }
  }
  .action-wrapper {
    margin: 16px;
  }
  .rules-wrapper {
    background: transparent;
  }
}
</style>
